<template>
  <div v-bind="$attrs" class="card shadow-sm">
    <div class="p-4 pb-0 card-header">
      <div class="row">
        <div class="col-md-8 d-flex align-items-center">
          <h6 class="mb-0">{{ title }}</h6>
        </div>
      </div>
    </div>
    <div class="card-body pt-4 p-3">
      <ul class="list-group">
        <li
          v-for="(trace, index) of traceList"
          :key="index"
          class="list-group-item border-0 d-flex p-4 mb-2 bg-gray-100 border-radius-lg card-hover position-relative"
        >
          <div class="d-flex flex-column">
            <h6 class="mb-3 text-sm">{{ trace.stepName }}</h6>
            <span class="mb-2 text-xs">
              type: <span class="text-dark ms-sm-2 font-weight-bold text-break">{{ trace.type }}</span>
            </span>
            <span class="mb-2 text-xs">
              bizStep: <span class="text-dark ms-sm-2 font-weight-bold text-break">{{ trace.bizStep }}</span>
            </span>
            <span class="mb-2 text-xs">
              eventID: <span class="text-dark ms-sm-2 font-weight-bold text-break">{{ trace.eventID }}</span>
            </span>
            <span v-if="trace.action" class="mb-2 text-xs">
              action: <span class="text-dark ms-sm-2 font-weight-bold text-break">{{ trace.action }}</span>
            </span>
            <span class="mb-2 text-xs">
              eventTime: <span class="text-dark font-weight-bold ms-sm-2" text-break>{{ formatDate(trace.eventTime) }}</span>
            </span>
            <span class="mb-2 text-xs">
              disposition: <span class="text-dark ms-sm-2 font-weight-bold text-break">
                {{ trace.disposition + ' ( ' + trace.dispositionName + ' ) ' }}</span>
            </span>
            <span class="mb-2 text-xs">
              bizLocation: <span class="text-dark ms-sm-2 font-weight-bold text-break">{{ trace.bizLocation }} ( {{ trace.bizLocationName }} )</span>
            </span>
            <span class="mb-2 text-xs">
              readPoint: <span class="text-dark ms-sm-2 font-weight-bold text-break">{{ trace.readPoint }} ( {{ trace.readPointName }} )</span>
            </span>
          </div>
          <div class="hover-overlay d-flex justify-content-center align-items-center" @click="xmlModal(trace.eventID)">
            XML
          </div>
        </li>
      </ul>
    </div>
  </div>
  <EventXMLModal v-model:show="showXMLModal" :eventID="modalEventID" />
</template>

<script>
import EventXMLModal from "@/views/components/modal/EventXMLModal.vue";
export default {
  name: "ProductTraceCard",
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: "",
    },
    traceList: {
      type: Array,
      default: () => [],
    },
  },
  components: { 
    EventXMLModal,
  },
  data() {
    return {
      showXMLModal: false,
      modalEventID: '',
    };
  },
  methods: {
    xmlModal(eventID){
      this.modalEventID = eventID;
      this.showXMLModal = true;
    }
  }
};
</script>

<style scoped>
.card-hover:hover {
  background-color: #e9ecef !important;
}
.card-hover {
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.hover-overlay {
  position: absolute;
  top: 0;
  right: -100px;
  width: 100px;
  height: 100%;
  background-color: #2563eb;
  color: #fff;
  font-weight: bold;
  font-size: 0.85rem;
  transition: font-size 0.3s ease, right 0.3s ease;
  z-index: 10;
}

.card-hover:hover .hover-overlay {
  right: 0;
}

.hover-overlay:hover {
  font-size: 1rem;
}
</style>